
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MicTest extends Vue {
  @Prop({ type: String, default: '' }) deviceId!: string;

  isRunning = false;
  volume = 0;
  errorMessage = '';

  private stream: MediaStream | null = null;
  private audioContext: AudioContext | null = null;
  private animFrameId: number | null = null;

  async startTest(): Promise<void> {
    this.errorMessage = '';
    try {
      const constraints: MediaStreamConstraints = {
        audio: this.deviceId && this.deviceId !== 'none' ? { deviceId: { exact: this.deviceId } } : true,
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.audioContext = new AudioContext();
      const source = this.audioContext.createMediaStreamSource(this.stream);
      const analyser = this.audioContext.createAnalyser();
      analyser.fftSize = 256;
      source.connect(analyser);

      const dataArray = new Uint8Array(analyser.frequencyBinCount);
      this.isRunning = true;

      const tick = () => {
        if (!this.isRunning) return;
        analyser.getByteFrequencyData(dataArray);
        const sum = dataArray.reduce((a, b) => a + b, 0);
        this.volume = sum / (dataArray.length * 255);
        this.animFrameId = requestAnimationFrame(tick);
      };
      tick();
    } catch (e: unknown) {
      const err = e as DOMException;
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        this.errorMessage = 'マイクへのアクセスが拒否されました。ブラウザの設定を確認してください。';
      } else {
        this.errorMessage = 'マイクを取得できませんでした。';
      }
    }
  }

  stopTest(): void {
    this.isRunning = false;
    this.volume = 0;
    if (this.animFrameId !== null) {
      cancelAnimationFrame(this.animFrameId);
      this.animFrameId = null;
    }
    if (this.stream) {
      this.stream.getTracks().forEach((t) => t.stop());
      this.stream = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }

  beforeDestroy(): void {
    this.stopTest();
  }
}
